export enum AttributeEntryType {
  OFFICE_USE_ONLY = 'Office Use Only',
  OPTIONAL = 'Optional',
  REQUIRED = 'Required',
  POINT_NAME = 'Point Name',
  FEATURE_CODE = 'Feature Code',
}

export const fromOldEntryType = (entryType: string): AttributeEntryType => {
  switch (entryType) {
    case 'OfficeUseOnly':
      return AttributeEntryType.OFFICE_USE_ONLY;
    case 'Optional':
      return AttributeEntryType.OPTIONAL;
    case 'Required':
      return AttributeEntryType.REQUIRED;
    case AttributeEntryType.POINT_NAME:
    case AttributeEntryType.FEATURE_CODE:
    default:
      return entryType as AttributeEntryType;
  }
};

export const toOldEntryType = (entryType: AttributeEntryType): string => {
  switch (entryType) {
    case AttributeEntryType.OFFICE_USE_ONLY:
      return 'OfficeUseOnly';
    case AttributeEntryType.OPTIONAL:
      return 'Optional';
    case AttributeEntryType.REQUIRED:
      return 'Required';
    case AttributeEntryType.POINT_NAME:
    case AttributeEntryType.FEATURE_CODE:
    default:
      return entryType;
  }
};
